const TopSubNavBar = ({ topTab, worksheetTab, setWorksheetTab, tabList }) => {
  return (
    <div
      style={{
        backgroundColor: "#FFFFFF",
      }}
    >
      {tabList.map((tab) => {
        return (
          topTab === tab.name &&
          tab.subTabList.length > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "1.5vw",
                borderBottom: "1px solid #EBEBEB",
                fontSize: "16px",
                height: "60px",
              }}
            >
              {tab.subTabList.map((subTab) => (
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "0 1vw",
                    fontWeight:
                      worksheetTab === subTab.name ? "bold" : "normal",
                    borderBottom:
                      worksheetTab === subTab.name ? "2px solid #000" : "none",
                    height: "100%",
                  }}
                  onClick={() => setWorksheetTab(subTab.name)}
                >
                  {subTab.text}
                </span>
              ))}
            </div>
          )
        );
      })}
    </div>
  );
};

export default TopSubNavBar;
